module.exports = __webpack_public_path__ + "img/ic_myjobs_disabled.5e975d99.svg";